<form nz-form>
	<workflow-select-question-input [label]="'query.create.question.label' | translate"
									[placeholder]="'query.create.question.placeholder' | translate"
									[(key)]="key">
	</workflow-select-question-input>
	<nz-form-item>
		<nz-form-label nzFor="message">
			{{'query.create.query' | translate}}
		</nz-form-label>
		<textarea nz-input name="message" [(ngModel)]="message"></textarea>
	</nz-form-item>
	<div class="actions">
		<button nz-button [disabled]="!message" type="button" nzType="primary" (click)="create()">
			{{'query.create.button' | translate}}
		</button>
	</div>
</form>